import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { currentAccountSelector, getAccountsByLibraryId } from './AuthSelector';

export const currentLibrarySelector = state => state.getIn(['entities', 'libraries', state.getIn(['library', 'id'], '').toString()], Immutable.Map());
export const currentSiteSelector = state => state.getIn(['entities', 'sites', currentLibrarySelector(state).get('siteId')], Immutable.Map());

export const sortedPickupBranchSelector = createSelector(
  currentLibrarySelector,
  currentAccountSelector,
  (library, account) => {
    const branches = library.get('branches', Immutable.List());
    const preferredBranches = account ? account.get('preferredLocations') : Immutable.List();

    return branches
      .sortBy((branch) => {
        const branchPreference = preferredBranches.indexOf(branch.code);
        return branchPreference >= 0 ? branchPreference : branches.length;
      });
  }
);

export const getLinkedLibrariesById = createSelector(
  [currentLibrarySelector, getAccountsByLibraryId],
  (library, accountsByLibraryId) => (
    library
      .get('linkableLibraries', Immutable.List())
      .filter(linkableLibrary => accountsByLibraryId.has(linkableLibrary.get('libraryId')))
      .groupBy(linkableLibrary => linkableLibrary.get('libraryId'))
      .map(libraryList => libraryList.first())
  )
);



// WEBPACK FOOTER //
// ./app/selectors/LibrarySelector.js